/* ============================================================================
   mm-language-selector.js — custom element <localization-form>
   ----------------------------------------------------------------------------
   Reprise du localization-form.js de Dawn. Chargé (defer) par
   sections/announcement-bar.liquid. Pilote les sélecteurs de langue/pays :
   - snippets/mm-country-selector.liquid et mm-country-selector-fixed.liquid
     (rendus par sections/header.liquid) ;
   - snippets/mm-language-selector.liquid.
   Le markup contient un <form> Shopify de localisation avec un input caché
   language_code/country_code : au clic sur un <a> de la liste, on copie la
   valeur choisie dans l'input et on soumet le form (rechargement de page sur
   la bonne locale / le bon marché). Gère aussi l'accessibilité du panneau
   (aria-expanded, fermeture sur Échap ou perte de focus).
   ========================================================================== */

class LocalizationForm extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
			button: this.querySelector("button"),
			panel: this.querySelector("ul"),
		};
		this.elements.button.addEventListener("click", this.openSelector.bind(this));
		this.elements.button.addEventListener("focusout", this.closeSelector.bind(this));
		this.addEventListener("keyup", this.onContainerKeyUp.bind(this));

		this.querySelectorAll("a").forEach((item) => item.addEventListener("click", this.onItemClick.bind(this)));
	}

	hidePanel() {
		this.elements.button.setAttribute("aria-expanded", "false");
		this.elements.panel.setAttribute("hidden", true);
	}

	onContainerKeyUp(event) {
		if (event.code.toUpperCase() !== "ESCAPE") return;

		this.hidePanel();
		this.elements.button.focus();
	}

	// Choix d'une langue/d'un pays : copie data-value dans l'input caché puis
	// soumet le form de localisation Shopify (recharge la page).
	onItemClick(event) {
		event.preventDefault();
		const form = this.querySelector("form");
		this.elements.input.value = event.currentTarget.dataset.value;
		if (form) form.submit();
	}

	openSelector() {
		this.elements.button.focus();
		this.elements.panel.toggleAttribute("hidden");
		this.elements.button.setAttribute("aria-expanded", (this.elements.button.getAttribute("aria-expanded") === "false").toString());
	}

	// Fermeture au focusout du bouton : seulement si le focus quitte tout
	// (relatedTarget null) ou repasse sur un bouton — laisse le panneau ouvert
	// quand le focus va sur un lien interne de la liste.
	closeSelector(event) {
		const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
		if (event.relatedTarget === null || shouldClose) {
			this.hidePanel();
		}
	}
}

customElements.define("localization-form", LocalizationForm);
